import React from 'react';
import SectionClosingStockReport from '../SectionClosingStockReport';
import * as goodsTransferApi from '@/services/goodsTransferApi';

const GoodsTransferClosingStock = () => {
  return (
    <SectionClosingStockReport
      sectionName="Goods Transfer"
      backRoute="/sections/goods-transfer"
      fetchClosingStock={goodsTransferApi.getGtClosingStock}
      fetchOperations={goodsTransferApi.getGtOperations}
      exportPrefix="goods_transfer"
      summaryGroupBy="design"
      showBundleCount={false}
    />
  );
};

export default GoodsTransferClosingStock;
